module.exports = __webpack_public_path__ + "static/praga-3-951c14cc9fcc84c7412237da193fca00.jpg";